<template>
  <div>
    <!-- 兑换优惠券列表配置 -->
    <div>
      <h4 class="describe">兑换实物</h4>
      <div class="activityListWrap">
        <h6 class="tips">活动配置</h6>
        <p class="careful">此处显示所有未开始或进行中的积分兑换活动</p>
        <!-- 配置表格 -->
        <div class="configTable">
          <div class="configTh">
            <span style="flex: 3;">名称</span>
            <span style="flex: 1;">状态</span>
            <span style="flex: 1;">图标</span>
            <span style="flex: 1;">排序</span>
            <span style="flex: 1;">操作</span>
          </div>

          <div class="configItem" v-for="(item, index) in pageConfig.integralShop.actualList" :key="'confingItem' + index">
            <div class="edit">
              <el-input v-if="item.goodName" class="ipt" v-model="item.goodName"></el-input>
              <el-input v-if="item.activityName" class="ipt" v-model="item.activityName"></el-input>
              <span class="state" v-if="item.status == 2">进行中</span>
              <span class="state" v-else-if="item.status == 1">未开始</span>
              <span class="state" v-else></span>
              <div class="icon">
                <img :src="item.imageUrl" @click="selectPicture(item)" />
              </div>
              <div class="sort">
                <i class="iconfont" :class="{ disabled: index == 0 }" @click="movePower({ id: item.id, type: 'moveUp' })">&#xe691;</i>
                <i
                  class="iconfont"
                  :class="{
                    disabled: index == pageConfig.integralShop.actualList.length - 1,
                  }"
                  @click="movePower({ id: item.id, type: 'moveDown' })"
                  >&#xe690;</i
                >
              </div>
              <div class="eye" @click="handleVisibility(item.id)">
                <i class="iconfont" :class="{ visible: !item.visibility }">&#xe695;</i>
              </div>
            </div>
            <!-- <div class="link">
              <el-input class="linkIpt" v-model="item.link"></el-input>
              <i
                class="jumpLink iconfont"
                @click="checkCurLinkItem(item), (linkAdminVisible = true)"
                >&#xe693;</i
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 图片库 -->
    <PhotoGallery :isShow="photoGalleryVisible" @close="photoGalleryChange"></PhotoGallery>
    <!-- 链接管理 -->
    <LInkAdmin :isShow="linkAdminVisible" @close="linkAdminChange"></LInkAdmin>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PhotoGallery from "@/components/PhotoGallery";
import LInkAdmin from "@/components/LInkAdmin";
import selectPictureMiXin from "@/mixin/selectPictureMiXin";

export default {
  components: {
    PhotoGallery,
    LInkAdmin,
  },
  data() {
    return {
      photoGalleryVisible: false,
      linkAdminVisible: false,
      aaa: [],
    };
  },
  computed: {
    ...mapState(["pageConfig"]),
  },
  mounted() {},
  mixins: [selectPictureMiXin],
  methods: {
    ...mapMutations(["movePower", "handleVisibility", "replaceIcon", "checkCurLinkItem", "editItemLink"]),
    // 选择链接后返回
    linkAdminChange(data) {
      this.linkAdminVisible = false;
      if (data) {
        //有数据返回
        this.editItemLink(data);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.describe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding-left: 28px;
  margin: 0;
  text-align: left;
  height: 64px;
  background-color: #f5f5f5;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  .desc {
    margin-top: 5px;
    color: #999;
    font-size: 14px;
    font-weight: 400;
  }
}
.state {
  flex: 1;
  color: #7b61ff;
  font-size: 14px;
  font-weight: 400;
}
.activityListWrap {
  box-sizing: border-box;
  padding: 20px 28px;
  text-align: left;
  border-bottom: 1px solid #f3f3f3;
  .tips {
    position: relative;
    display: inline-block;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    &::after {
      content: "*";
      position: absolute;
      right: -8px;
      top: 2px;
      color: #ff3a27;
    }
  }
  .careful {
    margin-top: 6px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
  }
  .configTable {
    margin-top: 20px;
    height: 600px;
    overflow: auto;
    .configTh {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 30px;
      height: 50px;
      background-color: #fafafa;
      span {
        color: #333;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .configItem {
      box-sizing: border-box;
      padding: 16px 30px 20px;
      border-bottom: 1px solid #f3f3f3;

      &:last-child {
        border: none;
      }
      .edit {
        display: flex;
        align-items: center;
        .ipt {
          flex: 3;
          height: 32px;
          /deep/ .el-input__inner {
            width: 90%;
            height: 32px;
          }
        }
        .icon {
          flex: 1;
          height: 35px;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            cursor: pointer;
          }
        }
        .sort {
          flex: 1;
          i {
            cursor: pointer;
            &.disabled {
              color: #dddddd;
              cursor: no-drop;
            }
          }
        }
        .eye {
          flex: 1;
          cursor: pointer;
          color: #666;
          .visible {
            color: #ccc;
          }
          i {
            transition: all 0.3s;
          }
        }
      }
      .link {
        position: relative;
        margin-top: 16px;
        .jumpLink {
          position: absolute;
          right: 1px;
          top: 1px;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #eeeeee;
          cursor: pointer;
        }
        .linkIpt {
          height: 32px;
          /deep/ .el-input__inner {
            height: 32px;
          }
        }
      }
    }
    .handle {
      box-sizing: border-box;
      padding-left: 30px;
      margin-top: 16px;
      color: #999;
      font-size: 13px;
      font-weight: 400;
      .add {
        display: inline-block;
        margin-right: 12px;
        cursor: pointer;
        color: #7f85e9;
      }
    }
  }
}
</style>
